import { createFileRoute } from '@tanstack/react-router';
import { Page } from '@/core/ui';
import { CreateCoursePage } from '@/modules/catalog/public';

export const Route = createFileRoute('/_app/cursos/novo')({
  component: function NewCourseRoute() {
    const navigate = Route.useNavigate();
    return (
      <Page>
        <CreateCoursePage
          onCreated={(slug) => navigate({ to: '/cursos/$slug/assistir', params: { slug } })}
        />
      </Page>
    );
  },
});
